import {
  handleSettingsAddSpecificLocations,
  handleSettingsMachineSelect,
  handleSettingsSpecificLocationSelect,
} from '../../../components/store/slices/settings/force&CommandAndAdminSelectSlice';

export const selectSpecificLocationIndicatorDispatcherHandler = (
  dispatch,
  name,
  specificLocationList,
  machineList,
  newSpecificLocations
) => {
  dispatch(
    handleSettingsSpecificLocationSelect({
      switch: name,
      arr: specificLocationList,
    })
  );
  dispatch(
    handleSettingsMachineSelect({
      switch: name,
      arr: machineList,
    })
  );
  dispatch(
    handleSettingsAddSpecificLocations({
      switch: name,
      arr: newSpecificLocations,
    })
  );
};
